<template>
    <div :class="$style.wrapper">
        <div style="margin-bottom:20px">
            <el-button type="info" size="small" @click="$router.push('/OrderList')">返回订单列表</el-button>
        </div>
        <div v-if="order===null">订单号：{{$route.params.id}}, 找不到该订单</div>
        <div v-else>
            <div :class="$style.header">
                <span>订单号：{{order.order_sn}}
                    <span
                        v-for="{status, name} in statusMap"
                        :key="status"
                        v-if="order.status===status"
                    >({{name}})
                    </span>
                </span>
                <Confirm v-if="order.status === 0" :handleConfirm="cancelOrder">
                    <el-button>取消订单</el-button>
                </Confirm>
                <el-button v-if="order.status===2||order.status===3">申请退款</el-button>
            </div>
            <el-steps :active="activeStep" finish-status="success" :align-center="true">
                <el-step
                    v-for="({name, time}, index) in steps"
                    :key="name"
                    :title="name"
                    :description="time"
                    :class="{active: index+1===activeStep}"
                ></el-step>
            </el-steps>
            <div :class="$style.banner">
                <div>
                    <span>收货人信息</span>
                    <span v-if="addressInfo">
                        {{addressInfo.consignee}},
                        {{addressInfo.address_str}}
                    </span>
                    <AddressDialog
                        v-if="order.status===0"
                        :type="4"
                        :editData.sync="addressInfo"
                        :order="order"
                    >
                        <span :class="$style.edit">[ 修改 ]</span>
                    </AddressDialog>
                    <span v-else-if="addressInfo">预约安装：{{addressInfo.is_yuyue_str || '未预约'}}</span>
                </div>
                <div>
                    <span>付款方式</span>
                    <span>{{order.pay_name}}</span>
                    <PayStyleDialog
                        v-if="order.status===0"
                        :update="getOrderDetail"
                        :order="order"
                    ><span :class="$style.edit">[ 修改 ]</span></PayStyleDialog>
                </div>
                <div>
                    <span>送货方式</span>
                    <span>由商家 <small>亿星商城</small> 发货</span>
                </div>
            </div>
            <div :class="$style.table">
                <el-table
                    :data="goods_list"
                    size="small"
                    style="width: 100%">
                    <el-table-column
                        align="center"
                        label="商品"
                        min-width="40%">
                        <template slot-scope="scope">
                            <div :class="$style.product">
                                <img :src="host + '/' + scope.row.goods_img" alt="">
                                <span style="text-align: left">
                                {{scope.row.goods_name}}
                                <pre style="font-size: 12px;margin: 0; line-height: 1.5">{{scope.row.goods_attr}}</pre>
                            </span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="单价"
                        min-width="20%">
                        <template slot-scope="scope">
                            <span style="color: #f74845">
                                {{scope.row.goods_price}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="数量"
                        min-width="20%"
                        prop="goods_number"
                    >
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="状态"
                        min-width="20%"
                    >
                        <template slot-scope="scope">
                            <span
                                v-for="{status, name} in statusMap"
                                :key="status"
                                v-if="scope.row.status_name===status"
                            >{{name}}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div :class="$style.pay">
                    <div><span>商品合计:</span><span>￥{{order.goods_amount}}</span></div>
                    <div><span>运费:</span><span>￥{{order.shipping_fee}}</span></div>
                    <div :class="$style.realPay"><span>实付款:</span><span>￥{{order.order_amount}}</span></div>
                    <el-button v-if="order.status===0&&order.is_upload===1" @click="handleClick">上传凭证</el-button>
                    <el-button v-else-if="order.status===0" @click="handleClick">支付</el-button>
                    <el-button v-else-if="order.status===1" disabled style="background: #AFAFAF">已关闭</el-button>
                    <el-button v-else disabled style="background: #AFAFAF">已支付</el-button>
                </div>
                <div :class="$style.bill">
                    <h1>发票信息</h1>
                    <span>发票类型：普通发票(纸质)</span>
                    <span>发票抬头：{{invoice && invoice.inv_type}}</span>
                    <span>发票内容：{{invoice && invoice.inv_payee}}</span>
                    <span>邮寄地址：{{addressInfo && addressInfo.address_str}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AddressDialog from '../components/Common/AddressDialog.vue';
    import PayStyleDialog from '../components/Common/PayStyleDialog.vue';
    import Confirm from '../components/Common/Confirm.vue';
    import { getOrderDetail, host, cancelOrder } from '../stores/api';
    import { statusMap } from '../utils/config';
    import Vue from 'vue';

    Vue.component('AddressDialog', AddressDialog);
    Vue.component('PayStyleDialog', PayStyleDialog);
    Vue.component('Confirm', Confirm);

    export default {
        data () {
            return {
                statusMap: statusMap,
                host: host,
                order: null,
                addressInfo: null,
                steps: [],
                activeStep: '',
                goods_list: [],
                invoice: null,
            };
        },
        beforeMount () {
            this.getOrderDetail();
        },
        methods: {
            getOrderDetail () {
                getOrderDetail(this.$route.params.id).then(res => {
                    this.order = res.data.orders;
                    this.goods_list = res.data.goods_list;
                    this.invoice = res.data.inv;
                    this.steps = res.data.orders.status_nav;
                    this.addressInfo = res.data.address;
                    // console.log(this.addressInfo)
                    for (let i = 0, len = res.data.orders.status_nav.length; i < len; i++) {
                        if (res.data.orders.status_nav[i].time === '') {
                            this.activeStep = i;
                            break;
                        }
                    }
                });
            },
            handleClick () {
                window.open(host + '/flow.php?step=order_pay&id=' + this.order.order_id);
            },
            cancelOrder () {
                this.isShow = false;
                cancelOrder(this.order.order_sn).then(() => {
                    this.$notify.success({
                        title: '操作成功',
                        message: '订单已取消',
                    });
                    this.order.status = 1;
                }).catch(err => {
                    this.$notify.error({
                        title: '操作成功',
                        message: err.message,
                    });
                });
            }
        },
    };
</script>

<style lang="less" module>
    .wrapper {
        .header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            & > span {
                font-size: 16px;
            }
            button {
                width: 78Px;
                height: 26Px;
                padding: 0;
                background: #f0f0f0;
                border: 1px solid #c7ccd4;
                border-radius: 2px;
                font-size: 12px;
                color: #636975;
            }
        }
        .banner {
            display: flex;
            margin: 20px 0;
            & > div:nth-child(2) {
                border-left: 0;
                border-right: 0;
            }
            & > div {
                width: 33.33%;
                height: 100px;
                display: flex;
                flex-direction: column;
                line-height: 35px;
                padding: 30px;
                font-size: 14px;
                border: 1px solid #d8dde6;
                & > span:nth-child(1) {
                    font-size: 16px;
                }
                & > span:nth-child(3) {
                    color: #f56c31;
                }
                small {
                    color: #f56c31;
                }
                .edit {
                    color: rgba(39, 149, 245, 0.8);
                    cursor: pointer;
                    &:hover {
                        color: #2795f5;
                    }
                }
            }

        }
        .table {
            border: 1px solid #d8dde6;
            td {
                vertical-align: top;
                font-size: 14px;
                .product {
                    display: flex;
                    img {
                        width: 60PX;
                        height: 60PX;
                        margin: 0 6px;
                    }
                }
            }
            .pay {
                padding: 40px;
                text-align: right;
                div > span {
                    width: 200px;
                    margin-bottom: 15px;
                    display: inline-block;
                    font-size: 14px;
                    color: #636975;
                    text-align: right;
                }
                & > button {
                    background: #f74845;
                    border-radius: 4px;
                    width: 126px;
                    height: 30px;
                    border: 0;
                    padding: 0;
                    color: #FFF;
                    font-size: 18px;
                    margin-top: 10px;
                }
                .realPay {
                    & > span:nth-child(1) {
                        font-size: 20px;
                        color: #1f2329;
                    }
                    & > span:nth-child(2) {
                        font-size: 20px;
                        color: #f74845;
                    }
                }
            }
            .bill {
                font-size: 14px;
                h1 {
                    margin: 10px 0;
                }
                margin: 0 40px;
                border-top: 1px solid #d8dde6;
                display: flex;
                flex-direction: column;
                line-height: 1.5;
                padding-bottom: 20px;
            }
        }

        :global {
            .el-steps {
                justify-content: space-between;
                .el-step {
                    flex-basis: initial !important;
                    .is-success, .is-process {
                        color: #c0c4cc;
                        font-weight: normal;
                    }
                }
                .el-step.is-center .el-step__line {
                    right: -325px;
                }
                .el-step.is-horizontal .el-step__line {
                    height: 10Px;
                    top: 7Px;
                }
                .el-step:last-of-type .el-step__line {
                    display: inherit;
                    width: 70px;
                    background-color: #FAFAFB !important;
                }
                .el-step__icon.is-text {
                    border: 0;
                    color: #c0c4cc;
                    background-color: #c0c4cc;
                }
                .el-step__head.is-success {
                    color: #FFF;
                    .el-step__icon.is-text {
                        color: #FFF;
                        background-color: #09bb07;
                    }
                    .el-step__line {
                        border-color: #09bb07;
                        background: #09bb07;
                    }
                }
                .el-step.is-center .el-step__description {
                    padding: 0;
                }
                .active .el-step__line {
                    border-color: inherit !important;
                    background-color: #c0c4cc !important;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/router/OrderDetail.vue